module.exports = __webpack_public_path__ + "static/banner.57e394ce.jpg";